import { useQuery } from "@apollo/client";
import { Combobox } from "@/components/Combobox";
import { type ComboboxOption } from "@/components/Combobox/types";
import { graphql, type ResultOf } from "@/graphql";
import { useActiveBusinessUnit } from "@/hooks/use-active-business-unit";
import { removeNothings } from "@/lib/utils/arrays";

type ContactId = string; // e.g. "5"

type Props = {
  id?: string;
  selected: Array<ContactId>;
  onSelect: (values: Array<ContactId>) => void;
  className?: string;
};

export type LotDestinationsData = ResultOf<typeof lotDestinationsQuery>;

export function DestinationPicker({ id, selected, onSelect, className }: Props) {
  const { activeBusinessUnitId } = useActiveBusinessUnit();
  const { data, loading } = useQuery(lotDestinationsQuery, { variables: { businessUnitId: activeBusinessUnitId } });

  const options: Array<ComboboxOption> = getDestinationOptions(data);

  return (
    <Combobox
      id={id}
      name="destinations"
      options={options}
      selected={selected}
      onChange={onSelect}
      loading={loading}
      type="multi"
      className={className}
    />
  );
}

export const getDestinationOptions = (data: LotDestinationsData | undefined) => {
  const options = removeNothings(data?.supplyChainLotDestinationPartners?.edges || []).map((destination) => {
    return {
      label: destination.node.businessName,
      value: destination.node.id,
    };
  });

  return options;
};

export const lotDestinationsQuery = graphql(`
  query SupplyChainLotDestinations($businessUnitId: ID) {
    supplyChainLotDestinationPartners(businessUnit: $businessUnitId) {
      edges {
        node {
          id
          businessName
        }
      }
    }
  }
`);
